module.exports = __webpack_public_path__ + "img/15.1f9959be.png";